<template>
  <div class="login">
    <img src="../assets/MM-lock-up@3x.png">
    <input type="text" v-model="email" placeholder="Email" class="rounded">
    <br>
    <input
      type="password"
      v-model="password"
      placeholder="Password"
      @keyup.enter="signIn"
      class="rounded"
    >
    <br>
    <button @click="signIn" class="rounded">Sign In</button>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "login",
  data: function() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    signIn: function() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            this.$router.replace("hello");
          },
          err => {
            alert("Oops. " + err.message);
          }
        );
    }
  }
};
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */
.login {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
img {
  width: 300px;
  margin-bottom: 2em;
}

input {
  margin: 10px 0;
  width: 20%;
  padding: 15px;
  font-size: 1em;
}

button {
  margin-top: 20px;
  width: 10%;
  cursor: pointer;
  padding: 0.5em;
  font-weight: bold;
  font-size: 1em;
  letter-spacing: 1px;
}
p {
  margin-top: 40px;
  font-size: 13px;
}
p a {
  text-decoration: underline;
  cursor: pointer;
}
.rounded {
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// Login.vue?5a6b1178